// @ts-nocheck
import { useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import OrderTable from './OrderTable';
import { getStatusColumns } from './util';
import {
  defaultTableSort,
  orderStatuses,
  orderTableTabs,
  orderValuesets,
} from './util/constants';
import type { Org } from '../../api/schemas/OrgSchema';
import type { OrderSummary } from '../../api/schemas/OrderSummarySchema';

interface MultistatusTableProps {
  ordersByStatus?: OrderSummary[];
  orgs: Org[];
  isLoading: boolean;
}

/**
 * Table with collapsable rows. Each row in the outer table expands to show another table
 */
const MultistatusTable = ({
  ordersByStatus,
  orgs,
  isLoading,
}: MultistatusTableProps) => {
  const orderStatusesDisplay = orderValuesets.status;

  const [expandedRows, setExpandedRows] = useState([
    orderStatusesDisplay[orderStatuses.PROCESSED],
    orderStatusesDisplay[orderStatuses.QC],
    orderStatusesDisplay[orderStatuses.DISPATCHED],
    orderStatusesDisplay[orderStatuses.SUBMITTED],
    orderStatusesDisplay[orderStatuses.SITE_SETUP],
  ]);
  const [currentSort, setCurrentSort] = useState(defaultTableSort);

  // Sets the current desired sort to apply to all children tables
  const handleColumnSort = (dataField, order) => {
    setCurrentSort({ dataField, order });
  };

  const data = [
    {
      tableStatus: orderStatusesDisplay[orderStatuses.PROCESSED],
    },
    {
      tableStatus: orderStatusesDisplay[orderStatuses.DISPATCHED],
    },
    {
      tableStatus: orderStatusesDisplay[orderStatuses.SITE_SETUP],
    },
    {
      tableStatus: orderStatusesDisplay[orderStatuses.SUBMITTED],
    },
  ];

  // If the row is already expanded, collapse
  // If the row is collapsed, expand
  const handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      setExpandedRows([...expandedRows, row.tableStatus]);
    } else {
      setExpandedRows(expandedRows.filter(r => r !== row.tableStatus));
    }
  };
  /**
   * Gets all orders of a particular status and applies the current text filter
   * @param {*} ordersByStatus - orders indexed by their status
   * @param {*} subTableDisplayStatus - status of orders to apply filter to
   */
  const getTableOrdersForStatus = (
    ordersByStatus: OrderSummary[],
    subTableDisplayStatus,
  ) => {
    // Get the integer status from the table display status
    const subtableIntegerStatus = Object.keys(orderStatusesDisplay).find(
      displayStatus =>
        subTableDisplayStatus === orderStatusesDisplay[displayStatus],
    );

    const groupedOrders = ordersByStatus.filter(order => {
      return order.status === Number(subtableIntegerStatus);
    });
    return groupedOrders;
  };

  /**
   * Renders a table in each expanded space of the parent table rows
   * Row expanding is externally controlled by the parent component
   */
  const rowExpand = {
    renderer: row =>
      !isLoading && ordersByStatus ? (
        <OrderTable
          orders={getTableOrdersForStatus(ordersByStatus, row.tableStatus)}
          editable
          orgs={orgs}
          sort={currentSort}
          activeTab={orderTableTabs.ONGOING}
          showHeader={false}
        />
      ) : null,
    expanded: expandedRows,
    onExpand: handleOnExpand,
  };

  return (
    <BootstrapTable
      expandRow={rowExpand}
      id="multistatus_table"
      data={data}
      bootstrap4
      keyField="tableStatus"
      columns={getStatusColumns(
        null,
        orderTableTabs.ONGOING,
        expandedRows,
        handleColumnSort,
      )}
      headerClasses="multitable-header"
      rowStyle={{ cursor: 'pointer' }}
      rowClasses={'multitable-row'}
      bordered={false}
      sort={{}}
    />
  );
};

export default MultistatusTable;
